import { OutboundMessage, OutboundMessageType, websocket } from '@playcastdotio/Messaging';
import { DateTime } from 'luxon';
import { invitationSendState } from '../../../stores/lobbyStores';
import { sendMessage } from '../';

export const handleOutboundMessage = (message: OutboundMessage) => {
  console.log('Outbound message:', message);

  switch (message.type) {
    case OutboundMessageType.OUTBOUND_LIMITS_REPLY: {
      // Handle quota limits reply
      console.log('Received quota limits:', message.email);
      invitationSendState.updateState({
        ...invitationSendState.currentState,
        reachedSmsInviteLimit: message.sms.count >= message.sms.limit,
        smsLimitExpiry: DateTime.fromISO(message.sms.limitExpiry).valueOf(),
        smsLimit: message.sms.limit,
        smsCount: message.sms.count,
        reachedEmailInviteLimit: message.email.count >= message.email.limit,
        emailLimitExpiry: DateTime.fromISO(message.email.limitExpiry).valueOf(),
        emailLimit: message.email.limit,
        emailCount: message.email.count,
      });
      break;
    }
    case OutboundMessageType.OUTBOUND_SMS_REPLY: {
      // Handle SMS reply
      console.log('Received SMS reply:', message.success);
      if (message.success) {
        invitationSendState.updateState({
          ...invitationSendState.currentState,
          smsCount: (invitationSendState.currentState.smsCount || 0) + 1,
        });
      }
      break;
    }
    case OutboundMessageType.OUTBOUND_EMAIL_REPLY: {
      // Handle email reply
      console.log('Received email reply:', message.success);
      if (message.success) {
        invitationSendState.updateState({
          ...invitationSendState.currentState,
          emailCount: (invitationSendState.currentState.emailCount || 0) + 1,
        });
      }
      break;
    }
    case OutboundMessageType.OUTBOUND_ERROR: {
      // Handle error
      console.error('Outbound error:', message.error);
      break;
    }
    default: {
      console.warn('Unknown outbound message type:', message.type);
    }
  }
};

export const requestQuotaLimits = () => {
  const message = websocket.generators.outbound(OutboundMessageType.OUTBOUND_LIMITS, {});
  sendMessage(message);
};

export const sendSms = (inviteId: string, phone: string, message: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_SMS, {
    inviteId,
    phone,
    message,
  });
  sendMessage(outboundMessage);
};

export const sendEmail = (inviteId: string, email: string, message?: string) => {
  const outboundMessage = websocket.generators.outbound(OutboundMessageType.OUTBOUND_EMAIL, {
    inviteId,
    email,
    message,
  });
  sendMessage(outboundMessage);
};
